<div id="advisor-notification-modal__container">
  <h3 class="title">{{ 'modals.advisor-notification.title' | translate }}</h3>
  <p class="message">{{ 'modals.advisor-notification.message' | translate }}</p>
  <div class="actions">
    <button nz-button nzType="primary" (click)="onButtonClicked()">
      {{ 'common.cta.understand' | translate }}
    </button>
  </div>
</div>
